<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Pagination from "@/components/standard/Induction/components/InductionPagination";
import EmployeeAPI from "@/services/employee/employeeAPI";
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Induction/components/InductionTable";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import EstiloVidaAPI from "@/services/standards/estiloVida/estiloVidaAPI";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import { dateFormat } from "@/utils/helpers/format";
import EstiloVidaPagination from "../../../components/standard/estiloVida/EstiloVidaPagination.vue";

/**
 * Basic Tables component
 */
export default {
  page: {
    title:
      "3.1.7 Estilo de vida y entornos saludables",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    Pagination,
    PageHeader,
    Table,
    CheckModal,
    EstiloVidaPagination,
  },
  data() {
    return {
      title:
        "3.1.7 Estilo de vida y entornos saludables",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Estilo de vida y entornos saludables",
          active: true,
        },
      ],
      list: [],
      themes: [],
      search: "",

      file: null,
      usersList: [],

      estilo: {
        activity: null,
        scheduled_date: null,
        observations: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      eliminacion: {
        type_document: null,
        file: null,
        description: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,

      company: null,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      loading1: true,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
    };
  },
  validations: {
    estilo: {
      employee_id: {
        required,
      },
      activity: {
        required,
      },
      scheduled_date: {
        required,
      },
    },
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItemData() {
      ItemAPI.getItems(29)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    save() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitted = false;
        this.loading1 = false;
        return;
      } else {
        EstiloVidaAPI.save(this.estilo)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 29,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(60, 29, true);
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1500);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 29)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/sst-prod/estandares/3.1.7/POLITICA_PREVENCION_CONSUMO_SPA_3.1.7.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    deleteEstilo(id) {
      EstiloVidaAPI.delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 29,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "Éxito!",
                text: "Se ha sido eliminado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getEstilo() {
      EstiloVidaAPI.get(this.companyID)
        .then((response) => {
          this.list = response.data.data;
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 29,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },
  },

  mounted() {
    this.getData();
    this.getItems();
    this.getUsers();
    this.getItemData();
    this.getEstilo();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12 pl-3">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe elaborar y ejecutar un programa para
                      promover entre los trabajadores, estilos de vida y
                      entornos de trabajo saludable, incluyendo campañas
                      específicas tendientes a la prevención y el control de la
                      fármaco dependencia, el alcoholismo y el tabaquismo, entre
                      otros.
                    </p>
                    <p class="text-justify">
                      En este ítem se podrá descargar un modelo de política para
                      la prevención y control del consumo de alcohol y
                      sustancias psicoactivas, además se deberá elaborar el
                      cronograma de las actividades relacionadas con el tema y
                      posteriormente subir las evidencias de su ejecución.
                    </p>
                  </CheckModal>
                </div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

              </div>

              <div class="row pt-3 px-3">
                <div class="col-12 d-flex justify-content-end">
                  <a href="#" @click="print"> Modelo de política promoción y prevención del consumo de sustancias
                    psicoactivas </a>
                </div>
              </div>

              <div class="row pt-3 px-3">
                <div class="col-8 text-right m-b-0"></div>
                <div class="col-4 text-right m-b-0">
                  <button :disabled="!allowAccess()" type="button" class="btn btn-primary ">
                    <router-link class="text-white" :to="{
                      path: `/forms/estandares/${this.companyID}/politica-alcohol-drogas`,
                    }">Política de No alcohol y
                      drogas
                    </router-link>
                  </button>

                  <br />

                </div>
              </div>

              <hr />

              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Actividad" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="estilo.activity" maxlength="100">
                    </b-form-textarea>
                    <div v-if="submitted && $v.estilo.activity.$error">
                      <small v-if="!$v.estilo.activity.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-6 px-2" label="Fecha Programada" label-for="trainingDate">
                    <b-form-input type="date" id="trainingDate" v-model="estilo.scheduled_date"
                      :disabled="!allowAccess() || !getRole('Crear')">
                    </b-form-input>
                    <div v-if="submitted && $v.estilo.scheduled_date.$error">
                      <small v-if="!$v.estilo.scheduled_date.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Responsable" label-for="employee">
                    <select id="employeeID" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="estilo.employee_id" :class="{
                        'is-invalid': $v.estilo.employee_id.$error && submitted,
                      }">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.estilo.employee_id.$error">
                      <small v-if="!$v.estilo.employee_id.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="estilo.observations" maxlength="200">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 px-3 pt-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1">
                    Cancelar
                  </button>
                </div>
              </form>
              <hr class="px-2" />
              <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="row pb-3">
                      <div class="col-6">
                        <form @submit.prevent="fetch()" class="form-inline">
                          <div class="form-group mr-2">
                            <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                              class="form-control px-2" placeholder="Buscar"></b-form-input>

                            <div class="col-1">
                              <button type="submit" class="btn btn-primary px-2">
                                Buscar
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="col-6"></div>
                    </div>

                    <div class="table-responsive">
                      <table
                        class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12">
                        <thead class="table-active">
                          <tr>
                            <th scope="col"
                              class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                              Fecha registro
                            </th>
                            <th scope="col"
                              class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                              Fecha programada
                            </th>

                            <th scope="col"
                              class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                              Responsable
                            </th>
                            <th scope="col"
                              class="px-6 text- text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4">
                              Actividad
                            </th>
                            <th scope="col"
                              class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                              Evidencia
                            </th>
                            <th scope="col"
                              class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                              Acciones
                            </th>
                          </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                          <tr v-for="item in list" :key="item.id">
                            <td class="px-6 text-sm text-gray-500 mx-2">
                              {{ dateConvert(item.created_at) }}
                            </td>

                            <td class="px-6 text-sm text-gray-500 mx-2">
                              {{ dateConvert(item.scheduled_date) }}
                            </td>

                            <td class="px-6 text-sm text-gray-500 mx-2">
                              {{ item.full_name }}
                            </td>
                            <td class="px-6 text-sm text-gray-500 mx-2">
                              {{ item.activity }}
                            </td>

                            <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
                              <div v-if="item.evidence === null">
                                <h6>No se ha subido una evidencia</h6>
                              </div>
                              <div v-else>
                                <button :disabled="!allowAccess()" style="
                                    background-color: transparent !important;
                                    border: none;
                                  " type="button" @click="gotoDigitalOcean(`${item.evidence}`)">
                                  <i class="mdi mdi-cloud-download"></i>
                                </button>
                              </div>
                            </td>
                            <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
                              <div class="col-sm-12">
                                <b-dropdown variant="primary" :disabled="!allowAccess() || !getRole('Editar')
                                  ">
                                  <template v-slot:button-content>
                                    <i class="mdi mdi-eye"></i>
                                  </template>
                                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')
                                    " :to="{
                                      path: `/forms/estandares/estilo-vida-evidencia/${item.id}`,
                                    }">
                                    Subir evidencia
                                  </b-dropdown-item>
                                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')
                                    " v-b-modal="`modal${item.id}`">
                                    Editar
                                  </b-dropdown-item>
                                  <b-modal :id="`modal${item.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                    <div class="text-justify">
                                      <h4 class="mt-2 text-primary text-center">
                                        Advertencia
                                      </h4>
                                      <p class="mt-3">
                                        Al modificar esta información se quitará
                                        el puntaje correspondiente a este ítem y
                                        será necesario realizar nuevamente la
                                        validación por parte del usuario
                                        responsable de Emisión.
                                      </p>
                                      <button type="button" @click="
                                        goPage(
                                          `/forms/estandares/estilo-vida-editar/${item.id}`
                                        )
                                        " class="btn btn-primary my-2 mx-2" data-dismiss="`modal${item.id}`"
                                        :disabled="!allowAccess()">
                                        Continuar
                                      </button>
                                      <button type="button" @click="
                                        $bvModal.hide(`modal${item.id}`)
                                        " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                        Cancelar
                                      </button>
                                    </div>
                                  </b-modal>
                                  <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                    " v-on:click="deleteEstilo(item.id)">Eliminar</b-dropdown-item>
                                </b-dropdown>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <EstiloVidaPagination ref="paginator" @loading="(load) => (loading = load)" :search="search"
                        @fetch="(items) => (list = items)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
